<div class="card">
    <app-custom-grid [gridColConfig]="options" [template]="tryTest" (onButtonClick)="btnClick($event)" [paging]="true"
        [tableOptions]="gridOptions">
        <ng-template #tryTest>

            <button id="newCliente" (click)="add()"
                class="bg-emerald-500 hover:bg-emerald-700 text-white p-2 rounded-xl ">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                </svg>
            </button>
        </ng-template>
    </app-custom-grid>
    <app-custom-overlay-messagge [options]="dialogMessaggeOptions"
        (dialogClosed)="Cgrid?.refreshTable()"></app-custom-overlay-messagge>
</div>